import React from 'react'
import {
  Routes,
  Route,
} from "react-router-dom";

import DeviceDetailsAddUser from '../IT/DeviceDetailsAddUser.jsx'
import DeviceDetailsUpdateLaptop from '../IT/DeviceDetailsUpdateLaptop.jsx'
import DeviceDetailsUpdateMobile from '../IT/DeviceDetailsUpdateMobile.jsx'
import DeviceGrid from '../IT/DeviceGrid.jsx'
import Landing from '../defaultPages/Landing.jsx'
import Login from '../defaultPages/Login.jsx'
import Register from '../defaultPages/Register.jsx'
import ForgotPass from '../IT/ForgotPass.jsx'
import LeaveForm from '../forms/LeaveForm.jsx'
import LeaveCalendar from '../defaultPages/LeaveCalendar.jsx'
import UserRegister from '../defaultPages/UserRegister.jsx'

import ENGTimesheetsPage from '../engineering/ENGTimesheetsPage.jsx';

import ACCTimesheetsPage from '../accounts/ACCTimesheetsPage.jsx';

import ALLROADSydneyTrainsDashboard from '../ALLROAD/ALLROADSydneyTrainsDashboard.jsx'

import AllFormsPage from '../defaultPages/AllFormsPage.jsx';

// Auth Wrapper
import AuthWrapper from '../auth/AuthWrapper.jsx';

// Employee forms
import EmployeeForms from '../defaultPages/EmployeeForms.jsx';

// Dashboards
import MasterDashboard from '../dashboards/MasterDashboard.jsx';

// Asset Hire Pages
import AssetHirePageClient from '../assetHire/AssetHirePageClient.jsx';
import AssetItem from '../assetHire/AssetItem.jsx';
import CustomerCartPage from '../assetHire/CustomerCartPage.jsx';
import OrderRequistionForm from '../forms/OrderRequistionForm.jsx';
import AssetPublicDashboard from '../assetHire/AssetPublicDashboard.jsx';
import AssetReturnsParent from '../assetHire/AssetReturnsParent.jsx';
import AllocationsPage from '../allocations/AllocationsPage.jsx';
import AllocationJob from '../allocations/AllocationJob.jsx';
import AllroadDashboardPageDaily from '../dashboards/allroad/AllroadDashboardPageDaily.jsx';
import AllroadDashboardPageSummary from '../dashboards/allroad/AllroadDashboardPageSummary.jsx';
export default function Site() {

    // "rfc" for creating default boilerplate
  
    return (
    <Routes>
    {/* Public Routes */}
    <Route path="/" element={<Landing/>}/>
    <Route path="login" element={<Login/>}/>
    <Route path="register" element={<Register/>}/>
    <Route path="forgotPass" element={<ForgotPass/>}/>
    <Route path="landing" element={<Landing/>}/>
    <Route path="/leaveCalendar" element={<LeaveCalendar/>}/>
    <Route path="/leaveForm" element={<LeaveForm/>}/>
    <Route path='/allForms/OrderRequisitionForm' element={<OrderRequistionForm/>}/>

    {/* TODO: CHANGE THIS TO BE PROTECTED */}
    <Route path='/AssetHire/Inventory/:assetId' element={<AssetItem/>}/>
    <Route path='/AssetHire/Inventory' element={<AssetHirePageClient/>}/>
    <Route path='/AssetHire/Client/Cart' element={<CustomerCartPage/>}/>
    {/* HR ROUTES */}
    <Route path="/HR/*" element={
      <AuthWrapper department="HR">
        <Routes>
          <Route path="deviceDetails" element={<DeviceGrid/>}/>
        </Routes>
      </AuthWrapper>
    }/>
    
    {/* ENGINEERING */}
    <Route path="/ENG/*" element={
      <AuthWrapper department="ENGINEERING">
        <Routes>
          <Route path='Timesheets' element={<ENGTimesheetsPage/>}/>
        </Routes>
      </AuthWrapper>
    }/>

    {/* ACCOUNTS */}
    <Route path='/Accounts/*'element = {
      <AuthWrapper department="ACCOUNTS">
        <Routes>
          <Route path='Timesheets' element={<ACCTimesheetsPage/>}/>
        </Routes>
      </AuthWrapper>
    }
    />

    {/* MASTER ONLY */}
    {/* TODO: Add a route/organise roots for /public and /master */}
    <Route path='/deviceDetails/addUser' element={<DeviceDetailsAddUser/>}/>
    <Route path='/deviceDetails/updateLaptop' element={<DeviceDetailsUpdateLaptop/>}/>
    <Route path='/deviceDetails/updateMobile' element={<DeviceDetailsUpdateMobile/>}/>
    <Route path='userRegister' element={<UserRegister/>}/>


    
    <Route path="/DefaultUser/AllForms/" element={<AllFormsPage/>}/>

    {/* Default User Routes */}
    <Route path='/DefaultUser/EmployeeForms' element={<EmployeeForms/>}/>

    {/* TESTING: SNR MGMT DASHBOARD */}
    <Route path='/SNRMGMT/*'element = {
      <AuthWrapper department="SNRMGMT">
        <Routes>
          <Route path='Dashboard/Allroad/daily' element={<AllroadDashboardPageDaily/>}/>
          <Route path='Dashboard/Allroad/summary' element={<AllroadDashboardPageSummary/>}/>
          <Route path='MasterDashboard' element={<MasterDashboard/>}/>
          <Route path='AssetPublicDashboard' element={<AssetPublicDashboard/>}/>
          <Route path='AssetReturnsInternal' element={<AssetReturnsParent/>}/>
          <Route path='Allocations' element={<AllocationsPage/>}/>
          <Route path='Allocations/Job/:JobId' element={<AllocationJob/>}/>
        </Routes>
      </AuthWrapper>
    }

    />
      <Route path='/ALLROAD/*'element = {
        <AuthWrapper department="ALLROAD">
          <Routes>
            <Route path='SydneyTrainsDashboard' element={<ALLROADSydneyTrainsDashboard/>}/>  
          </Routes>
        </AuthWrapper>
      }
      />
    </Routes>
    )
}
